module.exports = __webpack_public_path__ + "static/media/politically-exposed.785824f3.svg";